import type { IntlShape } from 'react-intl';

const getVehicleTypes = ({
  formatMessage,
}: {
  formatMessage: IntlShape['formatMessage'];
}) => [
  {
    label: formatMessage({
      id: 'Passenger Transport',
    }),
    name: 'Passenger Transportation',
    groupBy: 'vehicle',
    groupLabel: formatMessage({
      id: 'Vehicle Type',
    }),
  },
  {
    label: formatMessage({
      id: 'Pickup',
    }),
    name: 'Pick-up',
    groupBy: 'vehicle',
    groupLabel: formatMessage({
      id: 'Vehicle Type',
    }),
  },
  {
    label: formatMessage({
      id: 'Truck',
    }),
    name: 'Truck',
    groupBy: 'vehicle',
    groupLabel: formatMessage({
      id: 'Vehicle Type',
    }),
  },
  {
    label: formatMessage({
      id: 'Trailer',
    }),
    name: 'Trailer',
    groupBy: 'vehicle',
    groupLabel: formatMessage({
      id: 'Vehicle Type',
    }),
  },
  {
    label: formatMessage({
      id: 'Taxi',
    }),
    name: 'Taxi',
    groupBy: 'vehicle',
    groupLabel: formatMessage({
      id: 'Vehicle Type',
    }),
  },
  {
    label: formatMessage({
      id: '2 Wheeler <= 50CC',
    }),
    name: '2 Wheeler <= 50CC',
    groupBy: 'motorcycle',
    groupLabel: formatMessage({
      id: 'Motorcycle',
    }),
  },

  {
    label: formatMessage({
      id: '2 Wheeler > 50CC',
    }),
    name: '2 Wheeler > 50CC',
    groupBy: 'motorcycle',
    groupLabel: formatMessage({
      id: 'Motorcycle',
    }),
  },
  {
    label: formatMessage({
      id: '3Wheeler',
    }),
    name: '3Wheeler',
    groupBy: 'motorcycle',
    groupLabel: formatMessage({
      id: 'Motorcycle',
    }),
  },
  {
    label: formatMessage({
      id: 'Electric Motorcycle',
    }),
    name: 'Electric Motorcycle',
    groupBy: 'motorcycle',
    groupLabel: formatMessage({
      id: 'Motorcycle',
    }),
  },
];

const getUsingPurpose = ({
  formatMessage,
}: {
  formatMessage: IntlShape['formatMessage'];
}) => [
  {
    label: formatMessage({
      id: 'Business use purpose',
    }),
    name: 'Business use purpose',
    groupBy: 'vehicle',
    groupLabel: formatMessage({
      id: 'Vehicle Type',
    }),
  },
  {
    label: formatMessage({
      id: 'None-business use purpose',
    }),
    name: 'None business use purpose',
    groupBy: 'vehicle',
    groupLabel: formatMessage({
      id: 'Vehicle Type',
    }),
  },
  {
    label: formatMessage({
      id: 'Trailer',
    }),
    name: 'Trailer',
    groupBy: 'vehicle',
    groupLabel: formatMessage({
      id: 'Vehicle Type',
    }),
  },
  {
    label: formatMessage({
      id: 'Truck',
    }),
    name: 'Truck',
    groupBy: 'vehicle',
    groupLabel: formatMessage({
      id: 'Vehicle Type',
    }),
  },
  {
    label: formatMessage({
      id: 'Taxi',
    }),
    name: 'Taxi',
    groupBy: 'vehicle',
    groupLabel: formatMessage({
      id: 'Vehicle Type',
    }),
  },
  {
    label: formatMessage({
      id: 'Special purpose vehicle with required load carrying capacity',
    }),
    name: 'Special purpose vehicle with required load carrying capacity',
    groupBy: 'vehicle',
    groupLabel: formatMessage({
      id: 'Vehicle Type',
    }),
  },
  {
    label: formatMessage({
      id: 'Special purpose vehicle without required load carrying capacity',
    }),
    name: 'Special purpose vehicle without required load carrying capacity',
    groupBy: 'vehicle',
    groupLabel: formatMessage({
      id: 'Vehicle Type',
    }),
  },
  {
    label: formatMessage({
      id: 'Pickup, minivan',
    }),
    name: 'Pickup minivan',
    groupBy: 'vehicle',
    groupLabel: formatMessage({
      id: 'Vehicle Type',
    }),
  },
  {
    label: formatMessage({
      id: 'None-business Pickup, minivan',
    }),
    name: 'None business Pickup minivan',
    groupBy: 'vehicle',
    groupLabel: formatMessage({
      id: 'Vehicle Type',
    }),
  },
  {
    label: formatMessage({
      id: 'Armored car',
    }),
    name: 'Armored car',
    groupBy: 'vehicle',
    groupLabel: formatMessage({
      id: 'Vehicle Type',
    }),
  },
  {
    label: formatMessage({
      id: 'Ambulance',
    }),
    name: 'Ambulance',
    groupBy: 'vehicle',
    groupLabel: formatMessage({
      id: 'Vehicle Type',
    }),
  },
  {
    label: formatMessage({
      id: 'Special Vehicle',
    }),
    name: 'Special Vehicle',
    groupBy: 'vehicle',
    groupLabel: formatMessage({
      id: 'Vehicle Type',
    }),
  },
  {
    label: formatMessage({
      id: '2 Wheeler <= 50CC',
    }),
    name: '2 Wheeler <= 50CC',
    groupBy: 'motorcycle',
    groupLabel: formatMessage({
      id: 'Motorcycle',
    }),
  },

  {
    label: formatMessage({
      id: '2 Wheeler > 50CC',
    }),
    name: '2 Wheeler > 50CC',
    groupBy: 'motorcycle',
    groupLabel: formatMessage({
      id: 'Motorcycle',
    }),
  },
  {
    label: formatMessage({
      id: '3Wheeler',
    }),
    name: '3Wheeler',
    groupBy: 'motorcycle',
    groupLabel: formatMessage({
      id: 'Motorcycle',
    }),
  },
  {
    label: formatMessage({
      id: 'Electric Motorcycle',
    }),
    name: 'Electric Motorcycle',
    groupBy: 'motorcycle',
    groupLabel: formatMessage({
      id: 'Motorcycle',
    }),
  },
];

const getAllOptions = ({
  formatMessage,
}: {
  formatMessage: IntlShape['formatMessage'];
}) => [
  {
    label: formatMessage({
      id: 'Business use purpose',
    }),
    name: 'Business use purpose',
    groupBy: 'vehicle',
    groupLabel: formatMessage({
      id: 'Vehicle Type',
    }),
  },
  {
    label: formatMessage({
      id: 'None-business use purpose',
    }),
    name: 'None business use purpose',
    groupBy: 'vehicle',
    groupLabel: formatMessage({
      id: 'Vehicle Type',
    }),
  },
  {
    label: formatMessage({
      id: 'Trailer',
    }),
    name: 'Trailer',
    groupBy: 'vehicle',
    groupLabel: formatMessage({
      id: 'Vehicle Type',
    }),
  },
  {
    label: formatMessage({
      id: 'Truck',
    }),
    name: 'Truck',
    groupBy: 'vehicle',
    groupLabel: formatMessage({
      id: 'Vehicle Type',
    }),
  },
  {
    label: formatMessage({
      id: 'Taxi',
    }),
    name: 'Taxi',
    groupBy: 'vehicle',
    groupLabel: formatMessage({
      id: 'Vehicle Type',
    }),
  },
  {
    label: formatMessage({
      id: 'Special purpose vehicle with required load carrying capacity',
    }),
    name: 'Special purpose vehicle with required load carrying capacity',
    groupBy: 'vehicle',
    groupLabel: formatMessage({
      id: 'Vehicle Type',
    }),
  },
  {
    label: formatMessage({
      id: 'Special purpose vehicle without required load carrying capacity',
    }),
    name: 'Special purpose vehicle without required load carrying capacity',
    groupBy: 'vehicle',
    groupLabel: formatMessage({
      id: 'Vehicle Type',
    }),
  },
  {
    label: formatMessage({
      id: 'Pickup, minivan',
    }),
    name: 'Pickup minivan',
    groupBy: 'vehicle',
    groupLabel: formatMessage({
      id: 'Vehicle Type',
    }),
  },
  {
    label: formatMessage({
      id: 'None-business Pickup, minivan',
    }),
    name: 'None business Pickup minivan',
    groupBy: 'vehicle',
    groupLabel: formatMessage({
      id: 'Vehicle Type',
    }),
  },
  {
    label: formatMessage({
      id: 'Armored car',
    }),
    name: 'Armored car',
    groupBy: 'vehicle',
    groupLabel: formatMessage({
      id: 'Vehicle Type',
    }),
  },
  {
    label: formatMessage({
      id: 'Ambulance',
    }),
    name: 'Ambulance',
    groupBy: 'vehicle',
    groupLabel: formatMessage({
      id: 'Vehicle Type',
    }),
  },
  {
    label: formatMessage({
      id: 'Special Vehicle',
    }),
    name: 'Special Vehicle',
    groupBy: 'vehicle',
    groupLabel: formatMessage({
      id: 'Vehicle Type',
    }),
  },
  {
    label: formatMessage({
      id: '2 Wheeler <= 50CC',
    }),
    name: '2 Wheeler <= 50CC',
    groupBy: 'motorcycle',
    groupLabel: formatMessage({
      id: 'Motorcycle',
    }),
  },

  {
    label: formatMessage({
      id: '2 Wheeler > 50CC',
    }),
    name: '2 Wheeler > 50CC',
    groupBy: 'motorcycle',
    groupLabel: formatMessage({
      id: 'Motorcycle',
    }),
  },
  {
    label: formatMessage({
      id: '3Wheeler',
    }),
    name: '3Wheeler',
    groupBy: 'motorcycle',
    groupLabel: formatMessage({
      id: 'Motorcycle',
    }),
  },
  {
    label: formatMessage({
      id: 'Electric Motorcycle',
    }),
    name: 'Electric Motorcycle',
    groupBy: 'motorcycle',
    groupLabel: formatMessage({
      id: 'Motorcycle',
    }),
  },
];

const getNumberOfSearts = ({
  vehicleType,
  businessUsage,
}: {
  vehicleType: string;
  businessUsage: string;
}) => {
  const seatsA = [
    4, 5, 7, 8, 9, 12, 15, 16, 20, 24, 25, 29, 30, 35, 40, 45, 50, 55, 60,
  ];
  const seatsB: number[] = Array.from({ length: 60 - 4 + 1 }).map(
    (_, i) => i + 4,
  );

  const seatsE: number[] = [2, 3, 4, 5];

  if (vehicleType === 'Passenger Transportation') {
    return businessUsage === 'Yes'
      ? seatsB
      : businessUsage === 'No'
      ? seatsA
      : [];
  }

  if (vehicleType === 'Pick-up') {
    return seatsE;
  }

  if (vehicleType === 'Business use purpose') {
    //4 to 60, except 49、53-54、56-59
    return [
      4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
      24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
      42, 43, 44, 45, 46, 47, 48, 50, 51, 52, 55, 60,
    ];
  }
  // if (usingPurpose === 'None-business use purpose') {
  //   //4 to 60
  //   return [
  //     4, 5, 7, 8, 9, 12, 15, 16, 20, 24, 25, 29, 30, 35, 40, 45, 50, 55, 60,
  //   ];
  // }
  if (
    vehicleType === 'None-business use purpose' ||
    vehicleType === 'Trailer' ||
    vehicleType === 'Truck' ||
    vehicleType ===
      'Special purpose vehicle with required load carrying capacity' ||
    vehicleType ===
      'Special purpose vehicle without required load carrying capacity' ||
    vehicleType === 'Pickup, minivan' ||
    vehicleType === 'None-business Pickup, minivan' ||
    vehicleType === 'Armored car' ||
    vehicleType === 'Ambulance' ||
    vehicleType === 'Special Vehicle'
  ) {
    //1 to 60
    return [
      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
      22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39,
      40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57,
      58, 59, 60,
    ];
  }

  if (vehicleType === 'Taxi') {
    //1-8
    return [4, 5, 6, 7, 8];
  }

  return [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
    22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40,
    41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59,
    60,
  ];
};

export { getVehicleTypes, getNumberOfSearts, getUsingPurpose, getAllOptions };
